import {
  Directive,
  ElementRef,
  HostListener,
  model,
  inject,
} from '@angular/core';

@Directive({
  selector: '[coreMaxValue]',
})
export class MaxValueDirective {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);

  maxValue = model<number>(Number.MAX_SAFE_INTEGER, { alias: 'coreMaxValue' });

  @HostListener('input')
  onInput(): void {
    this.enforceMax();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text') ?? '';
    const numericValue = Number(pastedText);

    if (!isNaN(numericValue) && numericValue > this.maxValue()) {
      event.preventDefault();
      this.setValue(this.maxValue());
    }
  }

  @HostListener('blur')
  onBlur(): void {
    this.enforceMax();
  }

  private enforceMax(): void {
    const input = this.el.nativeElement;
    const value = Number(input.value);

    if (!isNaN(value) && value > this.maxValue()) {
      this.setValue(this.maxValue());
    }
  }

  private setValue(value: number): void {
    this.el.nativeElement.value = value.toString();
    const event = new Event('input', { bubbles: true });
    this.el.nativeElement.dispatchEvent(event);
  }
}
